var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    _vm._g({ staticClass: "mobile-panel-wrapper" }, _vm.$listeners),
    [
      _c("header", [_vm._t("header")], 2),
      _vm._v(" "),
      _c("article", [_vm._t("content")], 2),
      _vm._v(" "),
      _c(
        "footer",
        [
          _vm._t("footer", [
            _c("div", { staticClass: "control-buttons" }, [
              _c(
                "button",
                {
                  staticClass: "clear-button",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.$emit("clear")
                    }
                  }
                },
                [_vm._v("Wyczyść filtry")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button button-primary",
                  class: { active: _vm.active },
                  staticStyle: {
                    "padding-left": "60px",
                    "padding-right": "60px"
                  },
                  attrs: { "data-link": "menu", type: "submit" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.$emit("apply")
                    }
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "button-title",
                      attrs: { "data-count": _vm.dataCount }
                    },
                    [_vm._v("Zastosuj filtry")]
                  )
                ]
              )
            ])
          ])
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }